import { SelectOptionProps } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

import { State } from '@/types';

export function useStateOptions(): SelectOptionProps<State>[] {
  const { t } = useTranslation();

  return [
    {
      label: t('Activo'),
      value: State.Active,
    },
    {
      label: t('Inactivo'),
      value: State.Inactive,
    },
  ];
}
